<script>
import { Radar } from 'vue-chartjs'

export default {
  name: 'radarChart',
  extends: Radar,
  data: () => ({
    option: {
      responsive: true,
      maintainAspectRatio: false,
      spanGaps: false,
      tooltips: {
        callbacks: {
          title: (tooltipItem, data) => data.labels[tooltipItem[0].index],
        },
      },
      elements: {
        line: {
          tension: 0,
          borderWidth: 3,
        },
      },
    },
  }),
  props: {
    chartdata: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    this.renderChart(this.chartdata, this.option)
  },
}
</script>
